import { render, staticRenderFns } from "./vacancies_widget.vue?vue&type=template&id=6a4af7db&"
import script from "./vacancies_widget.vue?vue&type=script&lang=js&"
export * from "./vacancies_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../themes/chop-child/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/proservdemo25/public_html/wp-content/themes/chop-child/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4af7db')) {
      api.createRecord('6a4af7db', component.options)
    } else {
      api.reload('6a4af7db', component.options)
    }
    module.hot.accept("./vacancies_widget.vue?vue&type=template&id=6a4af7db&", function () {
      api.rerender('6a4af7db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "plugins/MtcBlockVacancies/assets/components/vacancies_widget.vue"
export default component.exports